import React from "react";
import { Typography, Box, Chip, Grid, CardMedia, Card } from "@mui/material";
import bmjVideo from "../assets/video/bmj-video.mp4"

const HeroSection = () => {
    return (
            <Grid container>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12} display="flex" justifyContent="center" alignItems="center">
                            {/* <video autoPlay muted loop >
                                <source src={bmjVideo} type="video/mp4" />
                            </video> */}
                            <Card raised={true} sx={{ maxWidth: "100%", maxHeight:"80vh" }}>
                                {/* <CardMedia
                                    component="video"
                                    allow="autoPlay"
                                    autoplay
                                    controls
                                    src={bmjVideo}
                                /> */}
                                <video autoPlay muted loop controls width="100%" height="100%">
                                <source src={"https://dqjggtpwr4ph6.cloudfront.net/bmj-video.mp4"} type="video/mp4" />
                            </video>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
    )
}

export default HeroSection